exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1NA0_jvhVKu6aWUfYP7fE8{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-sizing:border-box;box-sizing:border-box;min-height:14px}html[dir] ._1NA0_jvhVKu6aWUfYP7fE8{padding-bottom:11px}._2GrCcefxnMTMwn4u3gqt3b{width:100%;overflow:hidden;text-overflow:ellipsis;font-size:12px}html[dir=ltr] ._2GrCcefxnMTMwn4u3gqt3b{margin-left:13px}html[dir=rtl] ._2GrCcefxnMTMwn4u3gqt3b{margin-right:13px}._3k7hQjfCD6VJ-6-pPa2NAA{color:\"[theme:neutralSecondary, default:#666666]\"}._1CTC_Bg8bMnFJsxNdeIySH{color:\"[theme:neutralPrimary, default:#333333]\"}._3ch8J8YYiHHoRmbD_2d3e2{min-width:14px;color:\"[theme:neutralTertiary, default:#a6a6a6]\"}", ""]);

// exports
exports.locals = {
	"detailRow": "_1NA0_jvhVKu6aWUfYP7fE8",
	"detailRowText": "_2GrCcefxnMTMwn4u3gqt3b",
	"detailPlaceholderText": "_3k7hQjfCD6VJ-6-pPa2NAA",
	"detailText": "_1CTC_Bg8bMnFJsxNdeIySH",
	"detailRowIcon": "_3ch8J8YYiHHoRmbD_2d3e2"
};